import * as THREE from "three";

function hash3(x: number, y: number, z: number, seed: number): number {
  let value = (Math.imul(x | 0, 374761393) + Math.imul(y | 0, 668265263) + Math.imul(z | 0, 2147483647) + Math.imul(seed | 0, 1274126177)) | 0;
  value = Math.imul(value ^ (value >>> 13), 1274126177);
  value ^= value >>> 16;
  return (value >>> 0) / 0xffffffff;
}

function fade(t: number): number {
  return t * t * t * (t * (t * 6 - 15) + 10);
}

function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

export function valueNoise3(x: number, y: number, z: number, seed: number): number {
  const x0 = Math.floor(x);
  const y0 = Math.floor(y);
  const z0 = Math.floor(z);
  const tx = fade(x - x0);
  const ty = fade(y - y0);
  const tz = fade(z - z0);
  const values = new Float64Array(8);
  let cursor = 0;
  for (let dz = 0; dz <= 1; dz += 1) {
    for (let dy = 0; dy <= 1; dy += 1) {
      for (let dx = 0; dx <= 1; dx += 1) values[cursor++] = hash3(x0 + dx, y0 + dy, z0 + dz, seed);
    }
  }
  const x00 = lerp(values[0]!, values[1]!, tx);
  const x10 = lerp(values[2]!, values[3]!, tx);
  const x01 = lerp(values[4]!, values[5]!, tx);
  const x11 = lerp(values[6]!, values[7]!, tx);
  return lerp(lerp(x00, x10, ty), lerp(x01, x11, ty), tz);
}

export function fbmDirection(direction: THREE.Vector3, seed: number, octaves = 5): number {
  let amplitude = 0.5;
  let frequency = 1.0;
  let total = 0;
  let normalizer = 0;
  for (let octave = 0; octave < octaves; octave += 1) {
    total += valueNoise3(
      direction.x * frequency + 41.3,
      direction.y * frequency - 17.1,
      direction.z * frequency + 73.9,
      seed + octave * 1013,
    ) * amplitude;
    normalizer += amplitude;
    frequency *= 2.04;
    amplitude *= 0.5;
  }
  return total / normalizer;
}

export function ridgedDirection(direction: THREE.Vector3, seed: number, octaves = 4): number {
  let amplitude = 0.55;
  let frequency = 1.0;
  let total = 0;
  let normalizer = 0;
  for (let octave = 0; octave < octaves; octave += 1) {
    const raw = valueNoise3(
      direction.x * frequency + 101.7,
      direction.y * frequency + 39.2,
      direction.z * frequency - 55.8,
      seed + octave * 1877,
    );
    const ridge = 1 - Math.abs(raw * 2 - 1);
    total += ridge * ridge * amplitude;
    normalizer += amplitude;
    frequency *= 2.18;
    amplitude *= 0.48;
  }
  return total / normalizer;
}
